import React from "react";
import styled from "styled-components";
import { useCardElement } from "../../hooks/index";

const Body = styled.div`
  text-align: center;
  padding: 6px;
`;

export default (props) => {
  const ref = React.useRef(null);
  const [Child, setChild] = React.useState(<React.Fragment />);
  const renderCardElement = useCardElement();

  React.useEffect(() => {
    const children = renderCardElement(props.children);
    if (children) {
      setChild(
        <React.Fragment>
          <hr />
          {children}
          <hr />
        </React.Fragment>
      );
    }
  }, [ref.current]);
  return <Body ref={ref}>{Child}</Body>;
};



// WEBPACK FOOTER //
// ./src/_components/Card/components/Body/index.jsx